import {
  createSchemaPropertyList,
  getResolverServices,
  type ProjectSchemaJSON,
  type Resolver,
  type ShapeJSON
} from '@takeshape/schema';

export function getShapeServices(projectSchema: ProjectSchemaJSON, shape: ShapeJSON): string[] {
  const services = new Set<string>();
  const addAllServices = (resolver: Resolver) => {
    for (const id of getResolverServices(resolver)) {
      services.add(id);
    }
  };

  for (const query of Object.values(projectSchema.queries)) {
    if (query.shape === shape.name) {
      addAllServices(query.resolver);
    }
  }

  for (const query of Object.values(projectSchema.mutations)) {
    if (query.shape === shape.name) {
      addAllServices(query.resolver);
    }
  }

  for (const [, prop] of createSchemaPropertyList(projectSchema, shape).getNodes()) {
    const mappings = Array.isArray(prop['@mapping']) ? prop['@mapping'] : [prop['@mapping']];
    for (const mapping of mappings) {
      const serviceId = mapping?.substring(0, mapping.lastIndexOf(':'));
      if (serviceId) services.add(serviceId);
    }

    if (prop['@resolver']) {
      addAllServices(prop['@resolver']);
    }
  }

  return [...services];
}

export default getShapeServices;
